import React from 'react'
import './ProcessFailZouraDialog.css'
import Dialog from '../../../common/Dialog'
import $t from '../../../../i18n'
import { useDispatch, useSelector } from 'react-redux'
import actions from '../../../../actions'
import { DISPLAY_PERMISSIONS, routes } from '../../../../consts'
import Alert from '../../../common/Alert'

const ProcessFailZouraDialog = ({ onClose }) => {
  const dispatch = useDispatch()
  const isOpen = useSelector(state => state.payment.zouraProcessFailDialog)

  const onCloseDialog = () => {
    dispatch(
      actions.createAction(actions.CLOSE_UNABLE_TO_PROCESS_ZOURA_PAYMENT)
    )
    onClose()
  }
  const renderContent = () => (
    <span className="new-user-dialog-content">
      {$t('pages.billing.processFail')}
    </span>
  )
  return (
    <Alert
      title={$t('pages.billing.processFailTitle')}
      shouldDisplay={isOpen}
      onOk={onCloseDialog}
      className={'unsupported-dialog overwrite-email-existing-dialog'}
    >
      {renderContent()}
    </Alert>
  )
}

export default ProcessFailZouraDialog
